import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getFeedingBargesList,
	addNewFeedingBarges,
	updateFeedingBarges,
	deleteFeedingBarges,
	getFeedingBarges,
} from '../feedingBarges/thunk';

export const initialState = {
	itemFeedingBargesList: [],
	itemFeedingBargesDetail: null,
	isFeedingBargesLoading: false,
	isFeedingBargesSuccess: false,


	feedingBargesList: [],
	feedingBargesListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,

	isLoading: false,
	isSuccess: false,
	isError: false,
	error: ""
};

const FeedingBargesSlice = createSlice({
	name: 'FeedingBarges',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getFeedingBarges.fulfilled, (state, action) => {
			state.isFeedingBargesLoading = false;
			state.isFeedingBargesSuccess = true;
			state.itemFeedingBargesDetail = action.payload;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = true;
		});
		builder.addCase(getFeedingBarges.pending, state => {
			state.isFeedingBargesLoading = true;
			state.isFeedingBargesSuccess = null;
			state.error = null;
			state.isLoadingList = true;
			
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getFeedingBarges.rejected, (state, action) => {
			state.isFeedingBargesLoading = false;
			state.isFeedingBargesSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});

		builder.addCase(getFeedingBargesList.pending, state => {
			state.isFeedingBargesSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getFeedingBargesList.fulfilled, (state, action) => {
			state.itemFeedingBargesList = action.payload;
			state.feedingBargesList = action.payload;
			state.isLoadingList = false;
			state.isFeedingBargesSuccess = true;

			let feedingBargesListSelect = [];
			action.payload.map(item =>
				feedingBargesListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.feedingBargesListSelect = feedingBargesListSelect;
		});
		builder.addCase(getFeedingBargesList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isFeedingBargesSuccess = true;
		});
		builder.addCase(addNewFeedingBarges.fulfilled, (state, action) => {
			state.itemFeedingBargesList.push(action.payload);
			state.feedingBargesList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewFeedingBarges.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewFeedingBarges.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateFeedingBarges.fulfilled, (state, action) => {
			state.itemFeedingBargesList = state.itemFeedingBargesList.map(feedingBarges =>
				feedingBarges.feedingBargesname === action.payload.old_feedingBarges
					? { ...feedingBarges, ...action.payload.updated_feedingBarges }
					: feedingBarges
			);
			state.feedingBargesList = state.feedingBargesList.map(feedingBarges =>
				feedingBarges._id === action.payload._id
					? action.payload
					: feedingBarges
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateFeedingBarges.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateFeedingBarges.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteFeedingBarges.fulfilled, (state, action) => {
			state.itemFeedingBargesList = current(state.itemFeedingBargesList).filter(
				item => item._id !== action.payload._id
			);
			state.feedingBargesList = current(state.feedingBargesList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteFeedingBarges.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteFeedingBarges.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
		
	},
});

export const { setRequireCloseModal } = FeedingBargesSlice.actions;

export default FeedingBargesSlice.reducer;
